import React, { useEffect } from 'react';
import { EditProductForm, Maincontainer, Events, Metrics} from './components';
import { Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useStateValue } from './context/StateProvider';
import { getAllItems, getAllCompany, getSlider } from './utils/firebaseFunctions';
import { actionType } from './context/Reducer';
import HomeSlider from './components/HomeSlider';
import Gallery from './components/Gallery';
import Blog from './components/Videogallery';
import DonationAmounts from './components/DonationAmounts';
import AddExpense from './components/AddExpense';
import DonateNow from './components/DonateNow';
import Videogallery from './components/Videogallery';
import LordKrishna from './components/LordKrishna';
import Testimonials from './components/Testimonials';
import AddCategory from './components/AddCategory';
import Donationinkind from './components/Donationinkind';
import AddProduct from './components/AddProduct';

function App() {
  const [{ user, Products, }, dispatch] = useStateValue();
  const location = useLocation(); // Get the current route
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page on route change
  }, [location]);

  const fetchProductData = async () => {
    try {
      const data = await getAllItems();
      dispatch({
        type: actionType.SET_PRODUCT,
        Products: data,
      });
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };


  useEffect(() => {
    fetchProductData();
  }, [user]);

// Dynamic Title Logic
useEffect(() => {
  const routeTitleMap = {
    '/': 'Home - Goshala',
    '/createItem': 'Add Order - Goshala',
    '/addCompany': 'Add Staff - Goshala',
    '/viewItems': 'View Order - Goshala',
    '/addUser': 'Add User - Goshala',
    '/manageUsers': 'Manage Users - Goshala',
    '/addSlider': 'Add Slider - Goshala',
          '/addcategory': 'Add Category - Goshala', 
         '/donationinkind': 'Donationinkind -  Goshala',
        '/addproduct ': 'AddProduct -  Goshala',
  };

  document.title = routeTitleMap[location.pathname] || 'Goshala';
}, [location.pathname]);


  return (
    <AnimatePresence onExitComplete>
      <div className='w-full h-auto flex flex-col bg-white overflow-x-hidden'>
        <main className='w-full lg:overflow-hidden'>
          <Routes>
            <Route path='/*' element={<Maincontainer />} />
            {/* <Route path="/dashboard" element={<Dashboard/>} /> */}
            <Route path="/edit-product/:productId" element={<EditProductForm />} />
           <Route path="/homeslider" element={<HomeSlider/>} />
           <Route path="/gallery" element={<Gallery/>} />
           <Route path="/videogallery" element={<Videogallery/>} />
           <Route path="/event" element={<Events/>} />
           <Route path="/metrics" element={<Metrics/>} />
           <Route path="/DonationAmounts" element={<DonationAmounts/>} />
           <Route path="/addexpense" element={<AddExpense/>} />
           <Route path="/donatenow" element={<DonateNow/>} />
           <Route path="/lordkrishna" element={<LordKrishna/>} />
           <Route path="/testimonials" element={<Testimonials/>} />
             <Route path="/addcategory" element={<AddCategory/>} />
              <Route path="/donationinkind" element={<Donationinkind/>} />
               <Route path="/addproduct" element={<AddProduct/>} />
          </Routes>
        </main>
      </div>
    </AnimatePresence>
  );
}

export default App;
